module.exports = __webpack_public_path__ + "img/bg01.127a9516.png";